// import * as types from '../mutation-types'
import { services } from '../api'
import User from '../../assets/js/User.class'

const state = {
	main: {
		name: 'Alexander Pierce',
		position: 'Web Developer',
		state: {
			color: '#3c763d',
			name: 'Online'
		},
		createdAt: new Date()
	},
	user: null,
	token: null,
	token_type: null,
	usersData: null
}

const getters = {
	isLoggedIn (state) {
		return !!state.token && !!state.token_type && state.user.permissionAccess
	},
	getFrontUrl (state) {
		return state.user.frontUrlDomain
	}
}

const actions = {
	login ({ commit }, body) {
		return services.auth.login(body)
		.then((response) => {
			commit('SET_USER', response.data.data)
			commit('SET_TOKEN', response.data.access_token)
			commit('SET_TOKEN_TYPE', response.data.token_type)
			return response
		})
		.catch((error) => {
			console.error(error)
			commit('SET_USER', null)
			commit('SET_TOKEN', null)
			commit('SET_TOKEN_TYPE', null)
			return error.response
		})
	},
	loginSocial ({commit}, code) {
		return services.auth.loginSocial(code)
		.then((response) => {
			commit('SET_USER', response.data.data)
			commit('SET_TOKEN', response.data.access_token)
			commit('SET_TOKEN_TYPE', response.data.token_type)
			return response
		})
		.catch((error) => {
			console.error(error)
			commit('SET_USER', null)
			commit('SET_TOKEN', null)
			commit('SET_TOKEN_TYPE', null)
			return error.response
		})
	},
	checkUser ({commit}, {token, tokenType}) {
		return services.auth.checkUser()
			.then((response) => {
				if (response && response.data.data) {
					commit('SET_USER', response.data.data)
					commit('SET_TOKEN', token)
					commit('SET_TOKEN_TYPE', tokenType)
				}
				return response
			})
			.catch((error) => {
				console.error(error)
				commit('SET_USER', null)
				commit('SET_TOKEN', null)
				commit('SET_TOKEN_TYPE', null)
				return error.response
			})
	},
	logout ({commit}) {
		return services.auth.logout()
			.then((response) => {
				commit('SET_USER', null)
				commit('SET_TOKEN', null)
				commit('SET_TOKEN_TYPE', null)
				return response
			})
			.catch((error) => {
				console.error(error)
				commit('SET_USER', null)
				commit('SET_TOKEN', null)
				commit('SET_TOKEN_TYPE', null)
				return error.response
			})
	},
	getUsers ({commit}, params) {
		return services.user.getUsers(params)
			.then((response) => {
				commit('SET_USERS_DATA', response.data)
				return response
			})
			.catch((error) => {
				console.error(error)
				commit('SET_USERS_DATA', null)
				return error.response
			})
	},
	getUser ({commit}, id) {
		return services.user.getUser(id)
			.then((response) => {
				return response.data.data
			})
			.catch((error) => {
				console.error(error)
				// return error.response
			})
	},
	updateUser ({commit}, user) {
		return services.user.updateUser({
			formData: user.sendData.formData,
			id: user.id
		})
			.then((response) => {
				return response.data.data
			})
			.catch((error) => {
				console.error(error)
				// return error.response
			})
	}
}

const mutations = {
	SET_USER (state, user) {
		state.user = user ? new User(user) : null
	},
	SET_TOKEN (state, token) {
		state.token = token

		if (!token) {
			localStorage.removeItem('access_token')
		}
	},
	SET_TOKEN_TYPE (state, type) {
		state.token_type = type

		if (!type) {
			localStorage.removeItem('token_type')
		}
	},
	SET_USERS_DATA (state, users) {
		state.usersData = users
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js